export default __webpack_public_path__ + "population-500-0f83b5a4e4fd68a1999b217c89e82b26.webp";